import React, { useState } from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

type AccordionSectionProps = {
    title: string;
    children: React.ReactNode;
    domainConfiguration: DomainConfigurationDto;
    defaultOpen?: boolean;
};

export default function AccordionSection({
    title,
    children,
    domainConfiguration,
    defaultOpen = false
}: AccordionSectionProps) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div
            className="border-b cursor-pointer"
            style={{ borderColor: domainConfiguration.style.onBackgroundColor }}
            onClick={() => setIsOpen(!isOpen)}>
            <div className="w-full py-[16px] text-left flex items-center justify-between hover:opacity-70 transition-opacity group">
                <div className="flex items-center gap-24">
                    <span
                        className="text-[56px] font-montserrat-regular italic"
                        style={{
                            color: isOpen
                                ? domainConfiguration.style.primaryColor
                                : domainConfiguration.style.onBackgroundColor
                        }}>
                        #
                    </span>
                    <h3
                        className="text-headline-20 font-medium"
                        style={{
                            color: isOpen
                                ? domainConfiguration.style.primaryColor
                                : domainConfiguration.style.onBackgroundColor
                        }}>
                        {title}
                    </h3>
                </div>
                <svg
                    className={`size-[16px] transition-transform duration-300 ease-in-out ${
                        isOpen ? 'rotate-180' : 'rotate-0'
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2.5}
                    style={{ color: domainConfiguration.style.onBackgroundColor }}>
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </div>
            <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-96 pb-[24px]' : 'max-h-0 pb-0'
                }`}>
                <div className="pr-8">
                    <p
                        className="text-body-16 leading-relaxed"
                        style={{ color: withOpacity(domainConfiguration.style.onBackgroundColor, 0.7) }}>
                        {children}
                    </p>
                </div>
            </div>
        </div>
    );
}
